import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ChevronRightIcon} from '@/components/ui/icon/Icon'
import {InputHelpText} from '@/components/ui/input-help-text/InputHelpText'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {StyledAgendaToolbarTitle} from '@/features/agenda/components/agenda-toolbar-title/style'
import {useAgendaCategoryPatientAgeRange} from '@/features/agenda/hooks/useAgendaCategoryPatientAgeRange'
import {useAgendaSearchParams} from '@/features/agenda/hooks/useAgendaSearchParams'
import {useTranslation} from '@/translations/i18n'
import {PatientAgeRange} from '@/types'
import {workServiceToLabel} from '@/utilities/helpers'

export const AgendaToolbarPatientAgeRangeTitle = () => {
    const {t} = useTranslation()
    const {
        searchParams: {subjectIds, specializationIds, category},
        isPatientAgeRangeCategory
    } = useAgendaSearchParams()
    const {users, specializations, isLoading, isError} = useAgendaCategoryPatientAgeRange()

    const specialization = specializations.find(specialization => specialization.id === specializationIds?.[0])

    if (!isPatientAgeRangeCategory) {
        return null
    }

    if (isLoading) {
        return (
            <StyledAgendaToolbarTitle align="center" justify="center">
                <Skeleton height={24} width={200} />
            </StyledAgendaToolbarTitle>
        )
    }

    if (isError) {
        return (
            <StyledAgendaToolbarTitle align="center" justify="center">
                <InputHelpText error={t('errors:default')} />
            </StyledAgendaToolbarTitle>
        )
    }

    if (!users?.length) {
        return (
            <StyledAgendaToolbarTitle direction="column" align="center" justify="center">
                <Flexbox align="center" gap={1} render="h3">
                    {t(workServiceToLabel[category as PatientAgeRange])}
                    <ChevronRightIcon size={16} />
                    {specialization?.name}
                </Flexbox>
                <p>{t('commons:no_results')}</p>
            </StyledAgendaToolbarTitle>
        )
    }

    return (
        <Flexbox align="center" justify="center">
            <StyledAgendaToolbarTitle direction="column" align="center" justify="center">
                <Flexbox align="center" gap={1} render="h3">
                    {t(workServiceToLabel[category as PatientAgeRange])}
                    <ChevronRightIcon size={16} />
                    {specialization?.name}
                </Flexbox>
                {subjectIds && subjectIds.length > 0 && (
                    <p>{t('agenda:selected_operators_count', {count: subjectIds.length})}</p>
                )}
            </StyledAgendaToolbarTitle>
        </Flexbox>
    )
}
